// @ts-nocheck
import { interactivityRegistration, newXmlRequest } from "./Charta";
import { DomQuery, HtmlClassSwitch, WithClass, WithTagName } from "./Dom";
import { VisibilityChangedEvent } from "./Event";
import { application } from "./WebApp.Instance";
import { ToastMessage } from "./WebApp.ToastBox";
import { Labels, WebPageComponent } from "./WebSite.Page.Component";

export class UploadForm extends WebPageComponent {
  constructor(element) {
    super(element);

    this.element.component = this;

    this.fields = null;
    this.fileField = null;

    this.uri = this.element.dataset.Uri;
    this.determineElements();
    this.attachHandlers();
  }

  attachHandlers() {
    for (const field of this.fields) {
      if (field.name.slice(0, 7) == "Upload-") {
        if (field.type == "file") {
          this.fileField = field;
          field.onchange = (event) => { this.fileChanged(); };
        }
        else
          field.onchange = (event) => { this.inputChanged(); };
      }
    }
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.fields = query.getDescendants(WithTagName("INPUT"));
  }

  inputChanged(event) {
    const xmlRequest = new newXmlRequest();
    const formData = new FormData(this.element);

    xmlRequest.open("POST", this.uri, true);
    xmlRequest.onreadystatechange = () => { this.render(xmlRequest); };
    xmlRequest.send(formData);
  }

  fileChanged(event) {
    const uploadArea = this.element.parentNode;
    const files = this.fileField.files;

    uploadArea.component.processFiles(files);
  }

  refresh() {
    const xmlRequest = new newXmlRequest();

    xmlRequest.open("GET", this.uri, true);
    xmlRequest.onreadystatechange = () => { this.render(xmlRequest); };
    xmlRequest.send();
  }

  render(xmlRequest) {
    if (xmlRequest.readyState == 4) {
      const newFormDivision = document.createElement("div");
      newFormDivision.innerHTML = xmlRequest.responseText;

      interactivityRegistration.detach(this.element);
      const newForm = newFormDivision.firstChild;

      this.element.parentElement.replaceChild(newForm, this.element);
      this.element = newForm;

      interactivityRegistration.attach(newForm);
    }
  }
}

export class Form extends WebPageComponent {
  constructor(element) {
    super(element);

    this.initialize();
  }

  initialize() {
    this.loadingSwitch = new HtmlClassSwitch(this.element, "Loading");
    this.labels = new Labels(new DomQuery(this.element).getChild(WithClass("Labels")));

    if (this.asynchronous)
      this.initializeAsynchronous();
    else
      this.initializeSynchronous();
  }

  initializeAsynchronous() {
    this.element.addEventListener(
      "submit",
      (event) => {
        event.preventDefault();
        this.submitAsynchronous();
      }
    )
  }

  submitAsynchronous() {
    if (!this.loading) {
      this.loading = true;
      const formData = new FormData(this.element);

      fetch(
        this.uri,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          body: new URLSearchParams(formData).toString(),
          redirect: "manual"
        }
      )
        .then((response) => this.reloadAsynchronous(response));
    }
  }

  async reloadAsynchronous(response) {
    if (response.ok) {
      application.toastBox.addMessage(new ToastMessage(this.labels.SuccessfulSubmission, "Success"));
      await this.reloadForm(response);
    }
    else if (response.status === 400) {
      application.toastBox.addMessage(new ToastMessage(this.labels.WarningsInForm, "Warning"));
      await this.reloadForm(response);
    }
    else if (response.status >= 300 && response.status < 400)
      application.pageHandler.navigate(response.headers.get("Location"));
    else
      application.toastBox.addMessage(new ToastMessage(this.labels.ErrorsDuringSubmission, "Error"));

    this.loading = false;
  }

  async reloadForm(response) {
    const dummyElement = document.createElement("div");
    dummyElement.innerHTML = await response.text();

    const form = dummyElement.firstChild;

    interactivityRegistration.detach(this.element);
    this.element.parentElement.replaceChild(form, this.element);

    form.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });

    interactivityRegistration.attach(form);
  }

  initializeSynchronous() {
    this.alreadySubmitted = false;
    this.element.addEventListener(
      "submit",
      (event) => {
        if (this.alreadySubmitted) {
          event.preventDefault();
          alert("Form already submitted");

          return false;
        }
        else {
          this.alreadySubmitted = true;
          return true;
        }
      }
    );
  }

  handleEvent(event) {
    if (event instanceof VisibilityChangedEvent) {
      const element = this.getElementWithComponent(event.field);

      if (element !== null)
        this.updateVisibility(event.field, element);
    }
    else
      super.handleEvent(event);
  }

  getElementWithComponent(component) {
    let result = null;
    let index = 0;

    while (result === null && index < this.element.childNodes.length) {
      const node = this.element.childNodes[index];

      if (node.contains(component.element))
        result = node;
      else
        index++;
    }

    return result;
  }

  updateVisibility(field, element) {
    const visibility = new HtmlClassSwitch(element, "Hidden");
    visibility.setStatus(!field.visible);
  }

  focus() {
    const target = this.childComponents.find(child => child.isFocusable());

    if (target !== undefined)
      target.focus();
  }

  get asynchronous() {
    return this.element.dataset.Asynchronous === "true";
  }

  get name() {
    return this.element.dataset.Name;
  }

  get uri() {
    return this.element.dataset.Uri;
  }

  get loading() {
    return this.loadingSwitch.getStatus();
  }

  set loading(value) {
    this.loadingSwitch.setStatus(value);
  }
}

interactivityRegistration.register("Form", function (element) { return new Form(element); });
interactivityRegistration.register("UploadForm", function (element) { return new UploadForm(element); });
